import { Form, Input, Select, Row, Col, message, Modal, Switch, Drawer, Space, Button, InputNumber } from 'antd';
import { useEffect, useState, useRef } from 'react';
import styles from '../../../index.module.less';
import { addActivityProductShopLimit, updateActivityProductShopLimit } from '@/services/product';

const { Option } = Select;

const AddOrEditForm = (props: any) => {
  const [form] = Form.useForm();
  const { id, show, listRef, setVisible, editData, pid, psid, companyList = [] } = props;

  useEffect(() => {
    form.setFieldsValue(editData);
  }, [editData]);

  const onFinish = async (values) => {
    const data = {};
    if (!values.shopId) {
      message.error('请选择公司');
      return false;
    }
    data.shopId = values.shopId;

    if (!values.limitValue) {
      message.error('请输入限量');
      return false;
    }
    data.limitValue = values.limitValue;
    data.activityProductId = pid;

    if (id) {
      data.id = id;
      const res: any = await updateActivityProductShopLimit(data);
      if (res.id) {
        message.success('编辑成功');
        setVisible(false);
        listRef?.current?.reload();
      }
    } else {
      const res: any = await addActivityProductShopLimit(data);
      if (res.id) {
        message.success('新增成功');
        setVisible(false);
        listRef?.current?.reload();
      }
    }
  };

  const closeModal = () => {
    setVisible(false);
  };
  const onSubmit = () => {
    form.submit();
  };
  return (
    <Modal
      title={id ? '编辑' : '新增'}
      visible={show}
      onOk={onSubmit}
      onCancel={closeModal}
      width="600px"
      getContainer={false}
      okText="保存"
      destroyOnClose={true}
      cancelText="取消"
    >
      <div className={styles.case_content}>
        <Form preserve={false} className={styles.form_content} name="validate_other" onFinish={onFinish} form={form}>
          <Row>
            <Col span={11}>
              <Form.Item
                name="shopId"
                label="公司"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <Select placeholder="请选择" className={styles.case_item_select}>
                  {companyList.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.companyName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={2}></Col>
            <Col span={11}>
              <Form.Item
                name="limitValue"
                label="限量"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <InputNumber placeholder="请输入" className={styles.case_input_area} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
};

export default AddOrEditForm;
